import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { RdsChipsModule } from '../chips/index';
import { RdsBundleSelectionListComponent } from './bundle-selection-list.component';
import { RdsFormatChipsPipe } from './format-chips.pipe';

const COMPONENTS = [RdsBundleSelectionListComponent];
const PIPES = [RdsFormatChipsPipe];

@NgModule({
  imports: [CommonModule, MatListModule, MatIconModule, FormsModule, RdsChipsModule],
  declarations: [COMPONENTS, PIPES],
  exports: [COMPONENTS, PIPES]
})
export class RdsPackageBundleSelectionModule {}

export * from './bundle-selection-list.component';
export * from './format-chips.pipe';
